/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import ImageAttribution from '../shared/ImageAttribution';

const AssessmentIntroductionScreen = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Image" instructions="Describe an image that aligns with the context in this module." />
      <Controller 
        control={control}
        name="content.media"
        render={({ field }) => <ImageAttribution targetObj="content.media" inputDir={inputDir} errors={errors.content?.media} {...{control }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="English Introduction" instructions="Enter the content for the assessment introduction in English." />
      <Controller
        control={control}
        name="content.en_introduction"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.en_introduction} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="TL Introduction" instructions="Enter the content for the assessment introduction in the target language." />
      <Controller
        control={control}
        name="content.tl_introduction"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.tl_introduction} />}
      />

    </div>
  );
};

export default AssessmentIntroductionScreen;